import React, { useState, useEffect, useRef } from "react";
import SignaturePad from "./SignaturePad";
import Chrono from "./Chrono";
import PVIntermediaire from "./PVIntermediaire";
import { aiApi } from "./services/aiApi";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

export default function InterventionTechnicien({ T, intervention, currentUser, onClose, onFinished }) {
  const i = intervention;
  const [step, setStep]         = useState("info");
  const [rapport, setRapport]   = useState({
    nvr_installe:null, nvr_fonctionnel:null, connecte_internet:null, connecte_dolynkcare:null,
    raison_non_connexion:"", email_client:"", resume_installation:"",
    lieu_signature:i.client_ville||"", nom_signataire:"", qualite_signataire:"",
    signature_technicien:"", signature_client:"",
    checklist:[], observations_flash:""
  });
  const [errors, setErrors]     = useState({});
  const [saving, setSaving]     = useState(false);
  const [emailDraft, setEmailDraft] = useState({to:"", subject:"", body:""});
  const [emailSending, setEmailSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [pvPhotos, setPvPhotos] = useState([]);
  const [lightbox, setLightbox] = useState(null);
  const [loadingPhotos, setLoadingPhotos] = useState(false);
  const refCam = useRef();
  const refGal = useRef();
  const [showPVI, setShowPVI]   = useState(false);
  const [odooSignAvailable, setOdooSignAvailable] = useState(false);
  const [odooSign, setOdooSign] = useState(null); // {signRequestId, baseUrl, technicien:{itemId,token}, client:{itemId,token}}
  const [odooSignItems, setOdooSignItems] = useState(null); // [{role, state}]
  const [odooSignPhase, setOdooSignPhase] = useState("technicien"); // "technicien" | "client"
  const [odooSignLoading, setOdooSignLoading] = useState(false);
  const [odooSignError, setOdooSignError] = useState("");
  const odooPollRef = useRef(null);
  const [chronoFinal, setChronoFinal] = useState(null);

  // ── Assistant IA ──
  const [aiSynthLoading, setAiSynthLoading]     = useState(false);
  const [aiSynthError, setAiSynthError]         = useState(null);
  const [aiMaterielLoading, setAiMaterielLoading] = useState(false);
  const [aiMaterielError, setAiMaterielError]   = useState(null);
  const [aiMaterielItems, setAiMaterielItems]   = useState(null); // [{produit_id,designation,quantite,selected}] en attente de confirmation
  const [kmAlert, setKmAlert] = useState(null);

  useEffect(() => {
    if (!currentUser?.id) return;
    (async () => {
      try {
        const vehs = await fetch(`${BASE}/vehicules`, { headers: h() }).then(r => r.json());
        const mine = Array.isArray(vehs) ? vehs.find(v => v.technicien_id === currentUser.id) : null;
        if (!mine) return;
        const alertes = await fetch(`${BASE}/vehicule-alertes`, { headers: h() }).then(r => r.json());
        if (!Array.isArray(alertes)) return;
        const recent = new Date(Date.now() - 7 * 86400000);
        const a = alertes.find(a => a.vehicule_id === mine.id && a.type === "km_suspect" && !a.vu && new Date(a.created_at) > recent);
        if (a) setKmAlert(a);
      } catch {}
    })();
  }, [currentUser?.id]);

  const genererSynthese = async (champsNotes, contexte) => {
    const notes = champsNotes.map(c => rapport[c]).filter(Boolean).join("\n\n");
    if (!notes.trim()) { setAiSynthError("Renseignez d'abord le problème / les actions effectuées."); return; }
    setAiSynthLoading(true); setAiSynthError(null);
    try {
      const synthese = await aiApi.synthese(notes, contexte);
      upR("resume_intervention", synthese);
    } catch (e) {
      setAiSynthError(e.message);
    }
    setAiSynthLoading(false);
  };

  const analyserMateriel = async (champTexte) => {
    const texte = rapport[champTexte];
    if (!texte || !texte.trim()) { setAiMaterielError("Renseignez d'abord le matériel utilisé."); return; }
    setAiMaterielLoading(true); setAiMaterielError(null); setAiMaterielItems(null);
    try {
      const produits = await fetch(`${BASE}/stock-technicien/me`, { headers: h() }).then(r => r.json());
      const candidats = (Array.isArray(produits) ? produits : []).map(p => ({ id: p.produit_id, designation: p.designation, reference: p.prod_ref }));
      const items = await aiApi.parseMateriel(texte, candidats);
      const enrichis = items.map(it => {
        const p = candidats.find(c => String(c.id) === String(it.produit_id));
        return { produit_id: it.produit_id, quantite: it.quantite, designation: p?.designation || `Produit #${it.produit_id}`, selected: true };
      });
      setAiMaterielItems(enrichis.length ? enrichis : []);
    } catch (e) {
      setAiMaterielError(e.message);
    }
    setAiMaterielLoading(false);
  };

  const confirmerMateriel = async () => {
    const retenus = (aiMaterielItems || []).filter(it => it.selected);
    for (const it of retenus) {
      try {
        await fetch(`${BASE}/stock-technicien/mouvement`, {
          method: "POST", headers: h(),
          body: JSON.stringify({ produit_id: it.produit_id, type: "sortie", quantite: it.quantite, motif: "Détecté par IA sur rapport", intervention_id: i.id }),
        });
      } catch {}
    }
    setAiMaterielItems(null);
  };

  const AiSynthButton = ({ champs, contexte }) => (
    <div>
      <button onClick={()=>genererSynthese(champs, contexte)} disabled={aiSynthLoading}
        style={{padding:"5px 11px",borderRadius:8,background:T.accentDim,border:`1px solid ${T.accent}40`,color:T.accent,fontSize:11,fontWeight:700,cursor:aiSynthLoading?"default":"pointer",opacity:aiSynthLoading?0.6:1}}>
        {aiSynthLoading?"⏳ Génération...":"✨ Générer avec l'IA"}
      </button>
      {aiSynthError&&<div style={{fontSize:11,color:T.danger,marginTop:5}}>{aiSynthError}</div>}
    </div>
  );

  const AiMaterielButton = ({ champ }) => (
    <div>
      <button onClick={()=>analyserMateriel(champ)} disabled={aiMaterielLoading}
        style={{padding:"5px 11px",borderRadius:8,background:T.accentDim,border:`1px solid ${T.accent}40`,color:T.accent,fontSize:11,fontWeight:700,cursor:aiMaterielLoading?"default":"pointer",opacity:aiMaterielLoading?0.6:1}}>
        {aiMaterielLoading?"⏳ Analyse...":"✨ Analyser le matériel utilisé"}
      </button>
      {aiMaterielError&&<div style={{fontSize:11,color:T.danger,marginTop:5}}>{aiMaterielError}</div>}
    </div>
  );

  const TEMPLATE_NAMES = {pack_sentinelle:"📷 Pack Sentinelle",pack_flash:"🚨 Pack Flash Control",maintenance:"🔧 Maintenance",pack_sav:"🛠️ SAV",pack_cash_box:"💰 Pack Cash Box",depannage:"🛠️ Dépannage"};
  const templateNom = TEMPLATE_NAMES[i.modele_pv] || "📋 PV d'intervention";

  const isFlash = i.modele_pv === 'pack_flash';
  const isSentinelle = i.modele_pv === 'pack_sentinelle';
  const isMaintenance = i.modele_pv === 'maintenance';
  const isSav = i.modele_pv === 'pack_sav';
  const isCashBox = i.modele_pv === 'pack_cash_box';
  const [pvCameras, setPvCameras] = useState([]);
  const CHECKLIST_AJAX = [
    {id:1,label:"Enregistrement système",desc:"L'alarme a-t-elle été enregistrée sur Ajax PRO / GS-Group ?"},
    {id:2,label:"Carte SIM",desc:"Y a-t-il une carte SIM ? Si oui, correctement configurée ?"},
    {id:3,label:"Liaison télésurveillance",desc:"La centrale est-elle reliée au poste de contrôle ?"},
    {id:4,label:"Anti-brouillage",desc:"Le réglage anti-brouillage (anti-jamming) est-il activé ?"},
    {id:5,label:"Fuseau horaire",desc:"Le fuseau horaire est-il correctement configuré ?"},
    {id:6,label:"Sensibilité détecteurs",desc:"Les détecteurs sont-ils réglés en mode sensibilité haute ?"},
    {id:7,label:"Sensibilité sirènes",desc:"Les sirènes sont-elles réglées en mode Très Fort ?"},
    {id:8,label:"État des périphériques",desc:"Tous les périphériques sont-ils sans erreurs (état OK) ?"},
    {id:9,label:"Étiquettes GS-GROUP",desc:"Les étiquettes GS-GROUP sont-elles installées ?"},
    {id:10,label:"Mode groupe",desc:"Un mode groupe est-il configuré sur le système ?"},
    {id:11,label:"Zoning",desc:"Le zoning a-t-il été réalisé ?"},
  ];
  const MOTIFS_ALARME = [
    {id:"piles_hs",     label:"🔋 Piles HS / défectueuses"},
    {id:"defaut_com",   label:"📡 Défaut de communication"},
    {id:"fausse_alarme",label:"⚠️ Fausse alarme répétée"},
    {id:"sirene",       label:"🔊 Sirène défaillante"},
    {id:"detecteur",    label:"👁️ Détecteur défaillant"},
    {id:"clavier",      label:"⌨️ Clavier / Badge défaillant"},
    {id:"cablage",      label:"🔌 Câblage endommagé"},
    {id:"alimentation", label:"⚡ Défaut alimentation / batterie"},
    {id:"sabotage",     label:"🔨 Sabotage / dégradation"},
    {id:"autre",        label:"❓ Autre"},
  ];
  const MOTIFS_VIDEO = [
    {id:"camera_hs",    label:"📷 Caméra HS"},
    {id:"perte_image",  label:"🖼️ Perte image / mauvaise qualité"},
    {id:"nvr_defaillant",label:"💾 NVR / Enregistreur défaillant"},
    {id:"disque_dur",   label:"💿 Disque dur plein / défaillant"},
    {id:"acces_distant",label:"📱 Accès distant perdu"},
    {id:"cablage",      label:"🔌 Câblage endommagé"},
    {id:"alimentation", label:"⚡ Alimentation défectueuse"},
    {id:"firmware",     label:"🔄 Mise à jour firmware requise"},
    {id:"sabotage",     label:"🔨 Sabotage / dégradation"},
    {id:"autre",        label:"❓ Autre"},
  ];
  const EQ_CASH_BOX = [
    {id:"caisse",        label:"🖥️ Caisse enregistreuse"},
    {id:"imprimante",    label:"🖨️ Imprimante de caisse"},
    {id:"borne_commande",label:"📲 Borne de commande"},
    {id:"routeur",       label:"📶 Routeur / Box internet"},
    {id:"ecran_client",  label:"🖥️ Écran client"},
    {id:"tpe",           label:"💳 Terminal de paiement (TPE)"},
    {id:"tiroir_caisse", label:"📦 Tiroir-caisse"},
    {id:"lecteur_cb",    label:"🔍 Lecteur code-barres"},
    {id:"tablette",      label:"📱 Tablette tactile"},
  ];
  const TESTS_CASH_BOX = [
    {id:"impression",   label:"🖨️ Impression ticket de test"},
    {id:"paiement_cb",  label:"💳 Paiement CB fonctionnel"},
    {id:"connexion",    label:"📶 Connexion internet OK"},
    {id:"synchro",      label:"🔄 Synchronisation caisse / logiciel"},
    {id:"acces_distant",label:"📱 Accès distant configuré"},
    {id:"formation",    label:"🎓 Formation client effectuée"},
  ];

  const CHECKLIST_MAINTENANCE = [
    {id:1, label:"NVR / Enregistreur",      desc:"L'enregistreur est-il fonctionnel et accessible ?"},
    {id:2, label:"Espace disque",            desc:"L'espace disque est-il suffisant (>20% libre) ?"},
    {id:3, label:"Caméras opérationnelles",  desc:"Toutes les caméras sont-elles actives et visibles ?"},
    {id:4, label:"Qualité image",            desc:"La qualité d'image est-elle satisfaisante ?"},
    {id:5, label:"Horloge système",          desc:"L'horloge du NVR est-elle à l'heure ?"},
    {id:6, label:"Accès distant",            desc:"L'accès distant (Dolynkcare / app) est-il fonctionnel ?"},
    {id:7, label:"Enregistrement continu",   desc:"L'enregistrement tourne en continu sans interruption ?"},
    {id:8, label:"Nettoyage optiques",       desc:"Les optiques des caméras ont-elles été nettoyées ?"},
    {id:9, label:"État du câblage",          desc:"Le câblage est-il en bon état ?"},
    {id:10,label:"Alertes système",          desc:"Aucune alerte ou erreur active sur le système ?"},
    {id:11,label:"Mises à jour firmware",    desc:"Le firmware NVR / caméras est-il à jour ?"},
    {id:12,label:"Test détection mouvement", desc:"Le test de détection de mouvement est-il concluant ?"},
  ];

  useEffect(()=>{
    // Charger photos PV existantes
    fetch(`${BASE}/photos/${i.id}`,{headers:h()}).then(r=>r.json()).then(d=>setPvPhotos(Array.isArray(d)?d:[])).catch(()=>{});
    // Charger zones caméras pour Sentinelle
    fetch(`${BASE}/zones/${i.id}/cameras`,{headers:h()}).then(r=>r.json()).then(d=>{
      if(Array.isArray(d)&&d.length>0) setPvCameras(d);
      else setPvCameras(Array.from({length:4},(_,idx)=>({numero_camera:idx+1,zone:"",localisation:"",type_camera:"",ip:"",hdcvi:false,notes:""})));
    }).catch(()=>setPvCameras(Array.from({length:4},(_,idx)=>({numero_camera:idx+1,zone:"",localisation:"",type_camera:"",ip:"",hdcvi:false,notes:""}))));
    const endpoint = isFlash ? `${BASE}/rapport-flash/${i.id}` : isMaintenance ? `${BASE}/rapport-maintenance/${i.id}` : isSav ? `${BASE}/rapport-sav/${i.id}` : isCashBox ? `${BASE}/rapport-cash-box/${i.id}` : `${BASE}/rapport-sentinelle/${i.id}`;
    fetch(endpoint,{headers:h()}).then(r=>r.json()).then(d=>{
      if(d){
        if((isFlash||isMaintenance) && d.checklist){
          setRapport(p=>({...p,...d,checklist:d.checklist,motifs:d.motifs||p.motifs||[]}));
        } else if(d){
          setRapport(p=>({...p,...d}));
        }
      }
    }).catch(()=>{});
  },[]);

  const upR = (k,v) => setRapport(p=>({...p,[k]:v}));

  useEffect(() => {
    if(!isSentinelle) return;
    const nb = pvCameras.filter(c=>c.zone||c.localisation||c.ip).length;
    upR("nb_cameras", nb);
  }, [pvCameras, isSentinelle]);

  const compressImg = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Lecture fichier échouée"));
    reader.onload = e => {
      const img = new Image();
      img.onerror = () => {
        // Si compression échoue, envoyer le base64 brut
        resolve(e.target.result);
      };
      img.onload = () => {
        try {
          const scale = Math.min(1, 1200/img.width);
          const canvas = document.createElement("canvas");
          canvas.width = Math.round(img.width*scale);
          canvas.height = Math.round(img.height*scale);
          canvas.getContext("2d").drawImage(img,0,0,canvas.width,canvas.height);
          resolve(canvas.toDataURL("image/jpeg",0.75));
        } catch(err) {
          resolve(e.target.result); // fallback sans compression
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });

  const uploadPhotos = async (files) => {
    if(!files||!files.length) return;
    console.log("📸 uploadPhotos appelé", files.length, "fichier(s)");
    setLoadingPhotos(true);
    try {
      console.log("📸 Compression en cours...");
      // Comprimer et envoyer en base64 JSON (évite les problèmes FormData)
      const imgs = await Promise.all([...files].map(compressImg));
      const tok = localStorage.getItem("nexo_token");
      const r = await fetch(`${BASE}/photos/pv-json/${i.id}`, {
        method:"POST",
        headers:{Authorization:"Bearer "+tok, "Content-Type":"application/json"},
        body: JSON.stringify({photos: imgs, })
      });
      const res = await r.json().catch(()=>({}));
      if(res.uploaded || res.count) {
        const d = await fetch(`${BASE}/photos/${i.id}`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
        console.log('📸 Photos reçues:', d);
        setPvPhotos(Array.isArray(d)?d:[]);
      } else {
        // Fallback: essayer FormData direct
        const fd = new FormData();
        [...files].forEach(f => fd.append("photos", f));
        const r2 = await fetch(`${BASE}/photos/${i.id}`,{method:"POST",headers:{Authorization:"Bearer "+tok},body:fd});
        const res2 = await r2.json().catch(()=>({}));
        if(res2.uploaded || res2.count) {
          const d = await fetch(`${BASE}/photos/${i.id}`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
          setPvPhotos(Array.isArray(d)?d:[]);
        }
      }
    } catch(e) { console.error("Upload error:", e.message); }
    setLoadingPhotos(false);
  };

  const deletePhoto = async (photoId) => {
    await fetch(`${BASE}/photos/${photoId}`,{method:"DELETE",headers:h()}).catch(()=>{});
    setPvPhotos(p=>p.filter(ph=>ph.id!==photoId));
  };

  const saveDraft = async () => {
    const endpoint = isFlash ? `${BASE}/rapport-flash/${i.id}` : isMaintenance ? `${BASE}/rapport-maintenance/${i.id}` : isSav ? `${BASE}/rapport-sav/${i.id}` : isCashBox ? `${BASE}/rapport-cash-box/${i.id}` : `${BASE}/rapport-sentinelle/${i.id}`;
    await fetch(endpoint,{method:"POST",headers:h(),body:JSON.stringify({...rapport,valide:false})}).catch(()=>{});
  };

  const updChecklist = (id, val, obs) => {
    setRapport(p=>{
      const existing = (p.checklist||[]).find(c=>c.id===id);
      const updated = existing
        ? (p.checklist||[]).map(c=>c.id===id?{...c,valeur:val,observations:obs!==undefined?obs:c.observations}:c)
        : [...(p.checklist||[]),{id,valeur:val,observations:obs||""}];
      return {...p,checklist:updated};
    });
  };
  const getCheck = (id) => (rapport.checklist||[]).find(c=>c.id===id)||{valeur:null,observations:""};

  const validateQ = () => {
    const e={};
    if(isFlash){
      const missing = CHECKLIST_AJAX.filter(item=>getCheck(item.id).valeur===null);
      if(missing.length>0) e.checklist=`${missing.length} point(s) non renseigné(s)`;
      if(!rapport.resume_installation||rapport.resume_installation.length<10) e.resume_installation="Résumé trop court";
    } else if(isMaintenance){
      const missing = CHECKLIST_MAINTENANCE.filter(item=>getCheck(item.id).valeur===null);
      if(missing.length>0) e.checklist=`${missing.length} point(s) non renseigné(s)`;
      if(!rapport.resume_intervention||rapport.resume_intervention.length<10) e.resume_intervention="Résumé trop court (min 10 caractères)";
    } else if(isSav){
      if(!rapport.type_systeme) e.type_systeme="Sélectionnez le type de système";
      if(!rapport.motifs||rapport.motifs.length===0) e.motifs="Sélectionnez au moins un motif";
      if(!rapport.resultat) e.resultat="Sélectionnez le résultat";
      if(!rapport.resume_intervention||rapport.resume_intervention.length<10) e.resume_intervention="Résumé trop court";
    } else if(isCashBox){
      const eqCount = Object.values(rapport.equipements||{}).filter(q=>q>0).length;
      if(eqCount===0) e.equipements="Sélectionnez au moins un équipement";
      if(!rapport.resume_installation||rapport.resume_installation.length<10) e.resume_installation="Résumé trop court";
    } else {
      if(rapport.nvr_installe===null) e.nvr_installe="Obligatoire";
      if(rapport.nvr_fonctionnel===null) e.nvr_fonctionnel="Obligatoire";
      if(rapport.connecte_internet===null) e.connecte_internet="Obligatoire";
      if(rapport.connecte_internet===false&&!rapport.raison_non_connexion) e.raison_non_connexion="Précisez la raison";
      if(rapport.connecte_internet===true&&rapport.connecte_dolynkcare===null) e.connecte_dolynkcare="Obligatoire";
      if(!rapport.resume_installation||rapport.resume_installation.length<20) e.resume_installation="Résumé trop court (min 20 caractères)";
    }
    if(pvPhotos.length===0) e.photos="Ajoutez au moins une photo avant de continuer";
    setErrors(e); return Object.keys(e).length===0;
  };

  const RESULTAT_LABEL = {resolu:"✅ Problème résolu",partiel:"🔄 Partiellement résolu",non_resolu:"❌ Non résolu — retour nécessaire"};

  const buildSavEmail = () => {
    const systeme = rapport.type_systeme === "alarme" ? "système d'alarme" : "système de vidéosurveillance";
    const systemeTitle = rapport.type_systeme === "alarme" ? "Système d'alarme" : "Vidéosurveillance";
    const dateStr = new Date().toLocaleDateString("fr-FR",{weekday:"long",year:"numeric",month:"long",day:"numeric"});
    const resultatStr = RESULTAT_LABEL[rapport.resultat] || "—";
    let body = `Madame, Monsieur,\n\nNous vous informons que votre ticket SAV concernant votre ${systeme} a bien été clôturé.\n\n`;
    body += `─── Détails de l'intervention ───\n`;
    body += `Intervention : ${i.titre||"—"}\n`;
    body += `Date : ${dateStr}\n`;
    body += `Technicien : ${i.technicien_nom||"—"}\n`;
    body += `Résultat : ${resultatStr}\n\n`;
    if(rapport.resume_intervention) body += `${rapport.resume_intervention}\n\n`;
    if((rapport.resultat==="partiel"||rapport.resultat==="non_resolu")&&rapport.prochaine_action){
      body += `─── Prochaine action prévue ───\n${rapport.prochaine_action}\n\n`;
    }
    body += `Pour toute question, n'hésitez pas à nous contacter au 03.89.50.70.80.\n\n`;
    body += `Cordialement,\nL'équipe GS GROUP - To Be Secure\n12 Rue des Pyrénées, 68350 Brunstatt-Didenheim\nTél : 03.89.50.70.80 · www.gs-group.fr`;
    return {
      to: rapport.email_client||"",
      subject: `Clôture de votre ticket SAV — ${systemeTitle} — ${i.titre||""}`,
      body
    };
  };

  const handleFinish = async () => {
    const e={};
    if(!rapport.signature_technicien) e.signature_technicien="Obligatoire";
    if(!rapport.signature_client) e.signature_client="Obligatoire";
    setErrors(e); if(Object.keys(e).length>0) return;
    setSaving(true);
    const endpoint = isFlash ? `${BASE}/rapport-flash/${i.id}` : isMaintenance ? `${BASE}/rapport-maintenance/${i.id}` : isSav ? `${BASE}/rapport-sav/${i.id}` : isCashBox ? `${BASE}/rapport-cash-box/${i.id}` : `${BASE}/rapport-sentinelle/${i.id}`;
    await fetch(endpoint,{method:"POST",headers:h(),body:JSON.stringify({...rapport,valide:true})}).catch(()=>{});
    // Pour SAV : ouvrir le modal d'email de confirmation
    if(isSav){
      setEmailDraft(buildSavEmail());
      setSaving(false);
      setStep("email_confirm");
      return;
    }
    // Pour les autres modèles : envoyer le PV PDF si email renseigné
    if(rapport.email_client){
      await fetch(`${BASE}/pdf/send-pv/${i.id}`,{method:"POST",headers:h(),body:JSON.stringify({email:rapport.email_client,modele:i.modele_pv})}).catch(()=>{});
    }
    setSaving(false);
    setStep("termine");
    onFinished&&onFinished();
  };

  useEffect(() => {
    fetch(`${BASE}/odoo/sign-available`,{headers:h()}).then(r=>r.json()).then(d=>setOdooSignAvailable(!!d.available)).catch(()=>{});
  }, []);

  useEffect(() => () => { if(odooPollRef.current) clearInterval(odooPollRef.current); }, []);

  const pollOdooSignStatus = () => {
    if(odooPollRef.current) clearInterval(odooPollRef.current);
    odooPollRef.current = setInterval(async () => {
      const d = await fetch(`${BASE}/odoo/sign-request/intervention/${i.id}/status`,{headers:h()}).then(r=>r.json()).catch(()=>null);
      if(!d || d.error) return;
      setOdooSignItems(d.items);
      const techDone = d.items.find(it=>it.role==="TECHNICIEN")?.state==="completed";
      const cliDone = d.items.find(it=>it.role==="CLIENT")?.state==="completed";
      if(techDone) setOdooSignPhase(prev => prev==="technicien" ? "client" : prev);
      if(techDone && cliDone){
        clearInterval(odooPollRef.current); odooPollRef.current=null;
        upR("signature_technicien","ODOO_SIGN"); upR("signature_client","ODOO_SIGN");
      }
    }, 3000);
  };

  const startOdooSign = async () => {
    setOdooSignLoading(true); setOdooSignError("");
    try {
      const res = await fetch(`${BASE}/odoo/sign-request/intervention/${i.id}`,{method:"POST",headers:h()});
      const d = await res.json();
      if(!res.ok) throw new Error(d.error||`Erreur ${res.status}`);
      setOdooSign(d);
      pollOdooSignStatus();
    } catch(e) { setOdooSignError(e.message); }
    setOdooSignLoading(false);
  };

  const sendSavEmail = async (skip=false) => {
    if(!skip && emailDraft.to && emailDraft.subject && emailDraft.body){
      setEmailSending(true);
      await fetch(`${BASE}/rapport-sav/send-email/${i.id}`,{method:"POST",headers:h(),body:JSON.stringify(emailDraft)}).catch(()=>{});
      setEmailSending(false);
      setEmailSent(true);
      setTimeout(()=>{setStep("termine");onFinished&&onFinished();},1200);
    } else {
      setStep("termine");
      onFinished&&onFinished();
    }
  };

  const YesNo = ({field,label}) => (
    <div style={{marginBottom:16}}>
      <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:8}}>{label} <span style={{color:T.danger}}>*</span></div>
      <div style={{display:"flex",gap:10}}>
        {[["✅ Oui",true,"#22d3a0"],["❌ Non",false,"#ef4444"]].map(([lbl,val,col])=>(
          <button key={String(val)} onClick={()=>{upR(field,val);setErrors(e=>({...e,[field]:null}));}}
            style={{flex:1,padding:"13px",borderRadius:11,border:`2px solid ${rapport[field]===val?col:T.border}`,background:rapport[field]===val?col+"22":"transparent",color:rapport[field]===val?col:T.muted,fontSize:15,fontWeight:800,cursor:"pointer"}}>
            {lbl}
          </button>
        ))}
      </div>
      {errors[field]&&<div style={{fontSize:11,color:T.danger,marginTop:4}}>⚠ {errors[field]}</div>}
    </div>
  );

  const Counter = ({field,label,icon}) => (
    <div style={{marginBottom:14}}>
      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>{icon} {label}</div>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <button onClick={()=>upR(field,Math.max(0,(rapport[field]||0)-1))}
          style={{width:36,height:36,borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:18,cursor:"pointer",fontWeight:700,lineHeight:1}}>−</button>
        <span style={{minWidth:36,textAlign:"center",fontSize:16,fontWeight:800,color:T.accent}}>{rapport[field]||0}</span>
        <button onClick={()=>upR(field,(rapport[field]||0)+1)}
          style={{width:36,height:36,borderRadius:9,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:18,cursor:"pointer",fontWeight:700,lineHeight:1}}>+</button>
      </div>
    </div>
  );

  const steps=[{id:"info",ic:"📋",lbl:"Infos"},{id:"questionnaire",ic:"✅",lbl:"Questions"},{id:"signatures",ic:"✍️",lbl:"Signatures"}];
  const stepIdx=steps.findIndex(s=>s.id===step);

  if(step==="email_confirm") return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.92)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:T.card,borderRadius:16,width:"100%",maxWidth:560,maxHeight:"95vh",display:"flex",flexDirection:"column",overflow:"hidden"}}>
        {/* Header */}
        <div style={{background:"linear-gradient(135deg,#f59e0b,#ef4444)",padding:"18px 20px",display:"flex",alignItems:"center",gap:12,flexShrink:0}}>
          <div style={{width:40,height:40,borderRadius:10,background:"rgba(255,255,255,0.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20}}>📧</div>
          <div style={{flex:1}}>
            <div style={{fontSize:15,fontWeight:800,color:"#fff"}}>Envoyer la confirmation au client</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.8)"}}>Email de clôture SAV — modifiable avant envoi</div>
          </div>
        </div>

        {/* Corps du modal */}
        <div style={{flex:1,overflowY:"auto",padding:20,display:"flex",flexDirection:"column",gap:14}}>
          {emailSent&&(
            <div style={{background:"#10b98115",border:"1px solid #10b98140",borderRadius:10,padding:"12px 16px",display:"flex",alignItems:"center",gap:10}}>
              <span style={{fontSize:20}}>✅</span>
              <div style={{fontSize:13,fontWeight:700,color:T.success}}>Email envoyé avec succès !</div>
            </div>
          )}

          {/* Destinataire */}
          <div>
            <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:6}}>À (destinataire)</label>
            <input type="email" value={emailDraft.to} onChange={e=>setEmailDraft(p=>({...p,to:e.target.value}))} placeholder="client@exemple.fr"
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
            <div style={{fontSize:10,color:T.muted,marginTop:4}}>Envoi depuis noreply@gs-group.fr</div>
          </div>

          {/* Objet */}
          <div>
            <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:6}}>Objet</label>
            <input value={emailDraft.subject} onChange={e=>setEmailDraft(p=>({...p,subject:e.target.value}))} placeholder="Objet de l'email..."
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
          </div>

          {/* Corps */}
          <div style={{flex:1}}>
            <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:6}}>Message</label>
            <textarea value={emailDraft.body} onChange={e=>setEmailDraft(p=>({...p,body:e.target.value}))} rows={14}
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.7,fontFamily:"inherit"}}/>
          </div>

          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 14px",fontSize:11,color:T.muted,lineHeight:1.6}}>
            💡 Le PDF du rapport SAV n'est pas joint — cet email est uniquement la confirmation de clôture. Vous pouvez personnaliser le message avant l'envoi.
          </div>
        </div>

        {/* Footer actions */}
        <div style={{background:T.sidebar,borderTop:`1px solid ${T.border}`,padding:"12px 20px",display:"flex",gap:10,flexShrink:0}}>
          <button onClick={()=>sendSavEmail(true)} disabled={emailSending||emailSent}
            style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:14,fontWeight:600,cursor:"pointer"}}>
            Ignorer
          </button>
          <button onClick={()=>sendSavEmail(false)} disabled={emailSending||emailSent||!emailDraft.to}
            style={{flex:2,padding:"11px",borderRadius:10,background:emailDraft.to?`linear-gradient(135deg,#f59e0b,#ef4444)`:"#555",border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:emailDraft.to?"pointer":"not-allowed",opacity:emailSending?0.7:1}}>
            {emailSending?"Envoi en cours...":emailSent?"✅ Envoyé !":"📧 Envoyer la confirmation"}
          </button>
        </div>
      </div>
    </div>
  );

  if(step==="termine") return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.9)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,borderRadius:16,padding:40,textAlign:"center",maxWidth:440}}>
        <div style={{fontSize:64,marginBottom:16}}>🎉</div>
        <div style={{fontSize:24,fontWeight:800,color:T.success,marginBottom:8}}>Intervention clôturée !</div>
        <div style={{fontSize:13,color:T.muted,marginBottom:20}}>Rapport signé et validé avec succès.</div>
        <button onClick={onClose} style={{width:"100%",padding:"13px",borderRadius:11,background:`linear-gradient(135deg,${T.success},#16a34a)`,border:"none",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer"}}>
          Retour au tableau de bord
        </button>
      </div>
    </div>
  );

  return (
    <>
    <input ref={refCam} type="file" accept="image/*" capture="environment" onChange={e=>e.target.files.length&&uploadPhotos(e.target.files)} style={{display:"none"}}/>
    <input ref={refGal} type="file" accept="image/*" multiple onChange={e=>e.target.files.length&&uploadPhotos(e.target.files)} style={{display:"none"}}/>
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:1000,display:"flex",flexDirection:"column",overflow:"hidden"}}>

      {/* Header */}
      <div style={{background:T.sidebar,borderBottom:`1px solid ${T.border}`,padding:"12px 20px",display:"flex",alignItems:"center",gap:12,flexShrink:0}}>
        <div style={{width:38,height:38,borderRadius:10,background:`linear-gradient(135deg,${T.accent},${T.purple})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>📋</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:14,fontWeight:800,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{i.titre} · {templateNom}</div>
          <div style={{fontSize:11,color:T.muted}}>👤 {i.client_nom||"—"} · 📍 {i.client_ville||""}</div>
        </div>
        {i.client_telephone&&<a href={`tel:${i.client_telephone}`} style={{padding:"7px 12px",borderRadius:9,background:`${T.success}20`,border:`1px solid ${T.success}40`,color:T.success,fontSize:12,fontWeight:700,textDecoration:"none"}}>📞 Appeler</a>}
        <button onClick={()=>setShowPVI(true)} style={{padding:"7px 12px",borderRadius:9,background:`${T.warning}20`,border:`1px solid ${T.warning}40`,color:T.warning,fontSize:12,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>📋 PV Journée</button>
        <button onClick={async()=>{await saveDraft();onClose();}} style={{padding:"7px 12px",borderRadius:9,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:12,cursor:"pointer"}}>💾</button>
        <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:20}}>✕</button>
      </div>

      {/* Alerte trafic : risque de retard sur cette intervention (TomTom) */}
      {i.eta_route_retard&&(
        <div style={{background:"#ef444415",borderBottom:"1px solid #ef444440",padding:"8px 20px",display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
          <span style={{fontSize:13}}>🚦</span>
          <span style={{fontSize:11.5,color:"#ef4444",flex:1}}>
            Risque de retard — {i.eta_route_distance_km} km · {i.eta_route_duree_min} min
            {i.eta_route_arrivee&&` · arrivée estimée ${new Date(i.eta_route_arrivee).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}`}
          </span>
        </div>
      )}

      {/* Avertissement discret : écart kilométrique détecté cette semaine */}
      {kmAlert&&(
        <div style={{background:`${T.warning}15`,borderBottom:`1px solid ${T.warning}40`,padding:"8px 20px",display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
          <span style={{fontSize:13}}>⚠️</span>
          <span style={{fontSize:11.5,color:T.warning,flex:1}}>{kmAlert.message}</span>
          <span style={{fontSize:10,color:T.muted}}>Signalé au manager</span>
        </div>
      )}

      {/* Steps */}
      <div style={{background:T.sidebar,borderBottom:`1px solid ${T.border}`,padding:"10px 20px",display:"flex",alignItems:"center",flexShrink:0}}>
        {steps.map((s,si)=>{
          const done=si<stepIdx, active=step===s.id, col=done?T.success:active?T.accent:T.muted;
          return (
            <div key={s.id} style={{display:"flex",alignItems:"center",flex:si<steps.length-1?1:"auto"}}>
              <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:3,cursor:done?"pointer":"default"}} onClick={()=>done&&setStep(s.id)}>
                <div style={{width:32,height:32,borderRadius:"50%",background:done||active?col+"22":T.bg,border:`2px solid ${col}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>{done?"✓":s.ic}</div>
                <div style={{fontSize:10,color:col,fontWeight:active?800:500,whiteSpace:"nowrap"}}>{s.lbl}</div>
              </div>
              {si<steps.length-1&&<div style={{flex:1,height:2,background:done?T.success:T.border,margin:"0 6px",marginBottom:18}}/>}
            </div>
          );
        })}
      </div>

      {/* Content */}
      <div style={{flex:1,overflowY:"auto",padding:20}}>
        <div style={{maxWidth:660,margin:"0 auto"}}>

          {step==="info"&&(
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              <div style={{fontSize:18,fontWeight:800,color:T.text}}>📋 Fiche intervention</div>

              {/* Chronomètre */}
              <Chrono T={T} intervention={i} onStarted={()=>{}} onDureeChange={()=>{}} onCloture={()=>{ setChronoFinal(Date.now()); setStep("questionnaire"); }} onPVIntermediaire={()=>setShowPVI(true)} stopped={chronoFinal!==null} finalTime={chronoFinal}/>

              {/* Fiche client */}
              <div style={{background:T.card,border:`1px solid ${T.accent}40`,borderRadius:14,padding:18}}>
                <div style={{fontSize:12,fontWeight:800,color:T.accent,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:12}}>👤 Client</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  {[["🏢 Raison sociale",i.client_nom||"—"],["📍 Adresse",[i.client_adresse,i.client_ville].filter(Boolean).join(", ")||"—"],["📞 Téléphone",i.client_telephone||"—"],["📧 Email",i.client_email||"—"]].map(([label,val])=>(
                    <div key={label} style={{background:T.bg,borderRadius:9,padding:"10px 12px",border:`1px solid ${T.border}`}}>
                      <div style={{fontSize:11,color:T.muted,marginBottom:2}}>{label}</div>
                      <div style={{fontSize:13,fontWeight:600,color:T.text}}>{val}</div>
                    </div>
                  ))}
                </div>
                {i.client_telephone&&<a href={`tel:${i.client_telephone}`} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginTop:12,padding:"10px",borderRadius:10,background:`${T.success}20`,border:`1px solid ${T.success}40`,color:T.success,fontWeight:700,fontSize:14,textDecoration:"none"}}>📞 Appeler {i.client_nom}</a>}
              </div>

              {/* Info PV journée */}
              <div style={{background:`${T.warning}15`,border:`1px solid ${T.warning}40`,borderRadius:11,padding:"12px 16px",display:"flex",gap:12,alignItems:"flex-start"}}>
                <span style={{fontSize:22}}>📋</span>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:T.warning,marginBottom:3}}>Installation multi-journées ?</div>
                  <div style={{fontSize:12,color:T.muted}}>Utilisez le bouton <strong style={{color:T.warning}}>📋 PV Journée</strong> en haut pour créer un PV intermédiaire à la fin de chaque journée. Le client signe chaque soir.</div>
                </div>
              </div>
            </div>
          )}

          {step==="questionnaire"&&(
            <div style={{display:"flex",flexDirection:"column",gap:4}}>
              <div style={{fontSize:18,fontWeight:800,color:T.text,marginBottom:12}}>
                {isFlash?"🔒 Checklist Ajax — Pack Flash Control":isMaintenance?"🔧 Rapport de Maintenance":isSav?"🛠️ Rapport SAV":isCashBox?"💰 Pack Cash Box — Installation":"✅ Questionnaire"}
              </div>

              {/* ── SAV ── */}
              {isSav?(
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {/* Type système */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
                  <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Type de système <span style={{color:T.danger}}>*</span></div>
                  {errors.type_systeme&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.type_systeme}</div>}
                  <div style={{display:"flex",gap:10}}>
                    {[["alarme","🔒 Alarme"],["videosurveillance","📷 Vidéosurveillance"]].map(([val,lbl])=>(
                      <button key={val} onClick={()=>{upR("type_systeme",val);upR("motifs",[]);}}
                        style={{flex:1,padding:"12px",borderRadius:10,border:`2px solid ${rapport.type_systeme===val?T.accent:T.border}`,background:rapport.type_systeme===val?T.accentDim:"transparent",color:rapport.type_systeme===val?T.accent:T.muted,fontSize:14,fontWeight:800,cursor:"pointer"}}>
                        {lbl}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Motifs */}
                {rapport.type_systeme&&(
                  <div style={{background:T.card,border:`1px solid ${errors.motifs?T.danger:T.border}`,borderRadius:12,padding:14}}>
                    <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>
                      Motifs de l'intervention <span style={{color:T.danger}}>*</span>
                      <span style={{fontSize:10,fontWeight:400,color:T.muted,textTransform:"none",marginLeft:6}}>(plusieurs possibles)</span>
                    </div>
                    {errors.motifs&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.motifs}</div>}
                    <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                      {(rapport.type_systeme==="alarme"?MOTIFS_ALARME:MOTIFS_VIDEO).map(m=>{
                        const sel=(rapport.motifs||[]).includes(m.id);
                        return(
                          <button key={m.id} onClick={()=>{
                            const cur=rapport.motifs||[];
                            upR("motifs",sel?cur.filter(x=>x!==m.id):[...cur,m.id]);
                          }} style={{padding:"8px 14px",borderRadius:20,border:`2px solid ${sel?"#ef4444":T.border}`,background:sel?"#fee2e2":"transparent",color:sel?"#ef4444":T.muted,fontSize:12,fontWeight:700,cursor:"pointer"}}>
                            {m.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Description + casse */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14,display:"flex",flexDirection:"column",gap:12}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📋 Description du problème</div>
                    <textarea value={rapport.description_probleme||""} onChange={e=>upR("description_probleme",e.target.value)} rows={3} placeholder="Décrivez le problème constaté..."
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                  </div>
                  {/* Si casse/sabotage sélectionné → photos en avant */}
                  {(rapport.motifs||[]).some(m=>m==="sabotage"||m==="cablage")&&(
                    <div style={{background:"#fee2e215",border:"2px solid #ef444430",borderRadius:10,padding:12}}>
                      <div style={{fontSize:13,fontWeight:800,color:"#ef4444",marginBottom:10}}>📸 Photos des dégâts / dégradations</div>
                      {errors.photos&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.photos}</div>}
                      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                        <button onClick={()=>refCam.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:"#fee2e2",border:"1px solid #fca5a5",color:"#ef4444",fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📷 Prendre photo</button>
                        <button onClick={()=>refGal.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:"#fee2e2",border:"1px solid #fca5a5",color:"#ef4444",fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📁 Galerie</button>
                        {loadingPhotos&&<span style={{color:T.muted,fontSize:12,alignSelf:"center"}}>⏳ Envoi...</span>}
                      </div>
                      {pvPhotos.length>0&&<div style={{display:"flex",gap:8,flexWrap:"wrap"}}>{pvPhotos.map(ph=>(
                        <div key={ph.id} style={{position:"relative",width:90,height:90,borderRadius:8,overflow:"hidden",flexShrink:0}}>
                          <img src={ph.url} onClick={()=>setLightbox(ph.url)} style={{width:"100%",height:"100%",objectFit:"cover",cursor:"pointer"}} alt=""/>
                          <button onClick={()=>deletePhoto(ph.id)} style={{position:"absolute",top:2,right:2,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:4,cursor:"pointer",fontSize:12,padding:"2px 6px"}}>✕</button>
                        </div>
                      ))}</div>}
                    </div>
                  )}
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>🔧 Actions effectuées</div>
                    <textarea value={rapport.actions_effectuees||""} onChange={e=>upR("actions_effectuees",e.target.value)} rows={3} placeholder="Réglages, remplacement de pièces, configurations..."
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                  </div>
                  <div>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:7}}>
                      <div style={{fontSize:13,fontWeight:700,color:T.text}}>📦 Matériel remplacé</div>
                      <AiMaterielButton champ="materiel_remplace"/>
                    </div>
                    <textarea value={rapport.materiel_remplace||""} onChange={e=>upR("materiel_remplace",e.target.value)} rows={2} placeholder="Références, quantités..."
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                  </div>
                </div>

                {/* Résultat */}
                <div style={{background:T.card,border:`1px solid ${errors.resultat?T.danger:T.border}`,borderRadius:12,padding:14}}>
                  <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Résultat de l'intervention <span style={{color:T.danger}}>*</span></div>
                  {errors.resultat&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.resultat}</div>}
                  <div style={{display:"flex",flexDirection:"column",gap:8}}>
                    {[["resolu","✅ Problème résolu","#10b981"],["partiel","🔄 Partiellement résolu","#f59e0b"],["non_resolu","❌ Non résolu — retour nécessaire","#ef4444"]].map(([val,lbl,col])=>(
                      <button key={val} onClick={()=>upR("resultat",val)}
                        style={{padding:"11px 14px",borderRadius:10,border:`2px solid ${rapport.resultat===val?col:T.border}`,background:rapport.resultat===val?col+"22":"transparent",color:rapport.resultat===val?col:T.muted,fontSize:13,fontWeight:700,cursor:"pointer",textAlign:"left"}}>
                        {lbl}
                      </button>
                    ))}
                  </div>
                  {(rapport.resultat==="non_resolu"||rapport.resultat==="partiel")&&(
                    <div style={{marginTop:12}}>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📅 Prochaine action prévue</div>
                      <textarea value={rapport.prochaine_action||""} onChange={e=>upR("prochaine_action",e.target.value)} rows={2} placeholder="Décrivez la suite à donner..."
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                    </div>
                  )}
                </div>

                {/* Photos générales + résumé */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14,display:"flex",flexDirection:"column",gap:12}}>
                  {!(rapport.motifs||[]).some(m=>m==="sabotage"||m==="cablage")&&(
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}}>📸 Photos de l'intervention</div>
                      {errors.photos&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.photos}</div>}
                      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                        <button onClick={()=>refCam.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📷 Caméra</button>
                        <button onClick={()=>refGal.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📁 Galerie</button>
                        {loadingPhotos&&<span style={{color:T.muted,fontSize:12,alignSelf:"center"}}>⏳ Envoi...</span>}
                      </div>
                      {pvPhotos.length>0&&<div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>{pvPhotos.map(ph=>(
                        <div key={ph.id} style={{position:"relative",width:80,height:80,borderRadius:8,overflow:"hidden",flexShrink:0}}>
                          <img src={ph.url} onClick={()=>setLightbox(ph.url)} style={{width:"100%",height:"100%",objectFit:"cover",cursor:"pointer"}} alt=""/>
                          <button onClick={()=>deletePhoto(ph.id)} style={{position:"absolute",top:2,right:2,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:4,cursor:"pointer",fontSize:12,padding:"2px 5px"}}>✕</button>
                        </div>
                      ))}</div>}
                    </div>
                  )}
                  <div>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:7}}>
                      <div style={{fontSize:13,fontWeight:700,color:T.text}}>📝 Résumé de l'intervention <span style={{color:T.danger}}>*</span></div>
                      <AiSynthButton champs={["description_probleme","actions_effectuees","materiel_remplace"]} contexte={`Intervention SAV chez ${i.client_nom||"le client"}`}/>
                    </div>
                    <textarea value={rapport.resume_intervention||""} onChange={e=>upR("resume_intervention",e.target.value)} rows={4} placeholder="Synthèse de l'intervention..."
                      style={{background:T.bg,border:`1px solid ${errors.resume_intervention?T.danger:T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                    {errors.resume_intervention&&<div style={{fontSize:11,color:T.danger}}>{errors.resume_intervention}</div>}
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📧 Email client</div>
                      <input type="email" value={rapport.email_client||""} onChange={e=>upR("email_client",e.target.value)} placeholder="client@exemple.fr"
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                    </div>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📋 Observations</div>
                      <input value={rapport.observations||""} onChange={e=>upR("observations",e.target.value)} placeholder="Remarques complémentaires..."
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                    </div>
                  </div>
                </div>
              </div>
              ):isCashBox?(
              /* ── PACK CASH BOX ── */
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {/* Compteur matériel */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
                  <Counter field="nb_packs_cashbox" label="Nombre de packs Cash Box installés" icon="💰"/>
                </div>

                {/* Équipements installés */}
                <div style={{background:T.card,border:`1px solid ${errors.equipements?T.danger:T.border}`,borderRadius:12,padding:14}}>
                  <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Équipements installés <span style={{color:T.danger}}>*</span></div>
                  {errors.equipements&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.equipements}</div>}
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {EQ_CASH_BOX.map(eq=>{
                      const qty=(rapport.equipements||{})[eq.id]||0;
                      const checked=qty>0;
                      return(
                        <div key={eq.id} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 10px",borderRadius:9,background:checked?T.accentDim:"transparent",border:`1px solid ${checked?T.accent+"40":T.border}`,cursor:"pointer"}}
                          onClick={()=>{const cur=rapport.equipements||{};upR("equipements",{...cur,[eq.id]:checked?0:1});}}>
                          <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${checked?T.accent:T.border}`,background:checked?T.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                            {checked&&<span style={{color:"#fff",fontSize:13,fontWeight:900}}>✓</span>}
                          </div>
                          <div style={{flex:1,fontSize:13,fontWeight:checked?700:400,color:checked?T.text:T.muted}}>{eq.label}</div>
                          {checked&&(
                            <div style={{display:"flex",alignItems:"center",gap:6}} onClick={e=>e.stopPropagation()}>
                              <button onClick={()=>{const cur=rapport.equipements||{};const v=Math.max(1,(cur[eq.id]||1)-1);upR("equipements",{...cur,[eq.id]:v});}}
                                style={{width:28,height:28,borderRadius:6,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:16,cursor:"pointer",fontWeight:700,lineHeight:1}}>−</button>
                              <span style={{minWidth:24,textAlign:"center",fontSize:14,fontWeight:800,color:T.accent}}>{qty}</span>
                              <button onClick={()=>{const cur=rapport.equipements||{};upR("equipements",{...cur,[eq.id]:(cur[eq.id]||1)+1});}}
                                style={{width:28,height:28,borderRadius:6,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:16,cursor:"pointer",fontWeight:700,lineHeight:1}}>+</button>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Configuration */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
                  <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Configuration système</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                    {[["logiciel","💾 Logiciel / POS","Ex: Lightspeed, Zelty..."],["version_logiciel","🔢 Version","1.0.0"]].map(([k,lbl,ph])=>(
                      <div key={k}>
                        <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:5}}>{lbl}</div>
                        <input value={rapport[k]||""} onChange={e=>upR(k,e.target.value)} placeholder={ph}
                          style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                      </div>
                    ))}
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                    {[["ip","🌐 Adresse IP","192.168.x.x"],["ssid","📶 Réseau WiFi","Nom du réseau"]].map(([k,lbl,ph])=>(
                      <div key={k}>
                        <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:5}}>{lbl}</div>
                        <input value={(rapport.config_reseau||{})[k]||""} onChange={e=>upR("config_reseau",{...(rapport.config_reseau||{}),[k]:e.target.value})} placeholder={ph}
                          style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                      </div>
                    ))}
                  </div>
                  <div style={{marginTop:10}}>
                    <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:5}}>🔑 Licences / Codes d'activation</div>
                    <textarea value={rapport.licences||""} onChange={e=>upR("licences",e.target.value)} rows={2} placeholder="Numéros de licence, codes d'activation..."
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical"}}/>
                  </div>
                </div>

                {/* Tests */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
                  <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Tests effectués</div>
                  <div style={{display:"flex",flexDirection:"column",gap:6}}>
                    {TESTS_CASH_BOX.map(test=>{
                      const cur=rapport.checklist_tests||[];
                      const item=cur.find(t=>t.id===test.id)||{id:test.id,valeur:null};
                      return(
                        <div key={test.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",borderRadius:9,background:item.valeur===true?"#10b98108":item.valeur===false?"#ef444408":"transparent",border:`1px solid ${T.border}15`}}>
                          <div style={{flex:1,fontSize:13,color:T.text}}>{test.label}</div>
                          <div style={{display:"flex",gap:6}}>
                            {[["✅",true,"#10b981"],["❌",false,"#ef4444"]].map(([lbl,val,col])=>(
                              <button key={String(val)} onClick={()=>{
                                const updated=cur.filter(t=>t.id!==test.id);
                                upR("checklist_tests",[...updated,{id:test.id,valeur:val}]);
                              }} style={{padding:"5px 12px",borderRadius:7,border:`2px solid ${item.valeur===val?col:T.border}`,background:item.valeur===val?col+"22":"transparent",color:item.valeur===val?col:T.muted,fontSize:12,fontWeight:800,cursor:"pointer"}}>
                                {lbl}
                              </button>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Photos + résumé */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14,display:"flex",flexDirection:"column",gap:12}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}}>📸 Photos de l'installation</div>
                    {errors.photos&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.photos}</div>}
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>
                      <button onClick={()=>refCam.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📷 Caméra</button>
                      <button onClick={()=>refGal.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📁 Galerie</button>
                      {loadingPhotos&&<span style={{color:T.muted,fontSize:12,alignSelf:"center"}}>⏳ Envoi...</span>}
                    </div>
                    {pvPhotos.length>0&&<div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:8}}>{pvPhotos.map(ph=>(
                      <div key={ph.id} style={{position:"relative",width:80,height:80,borderRadius:8,overflow:"hidden",flexShrink:0}}>
                        <img src={ph.url} onClick={()=>setLightbox(ph.url)} style={{width:"100%",height:"100%",objectFit:"cover",cursor:"pointer"}} alt=""/>
                        <button onClick={()=>deletePhoto(ph.id)} style={{position:"absolute",top:2,right:2,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:4,cursor:"pointer",fontSize:12,padding:"2px 5px"}}>✕</button>
                      </div>
                    ))}</div>}
                  </div>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📝 Résumé de l'installation <span style={{color:T.danger}}>*</span></div>
                    <textarea value={rapport.resume_installation||""} onChange={e=>upR("resume_installation",e.target.value)} rows={4} placeholder="Matériel installé, configurations effectuées, tests validés..."
                      style={{background:T.bg,border:`1px solid ${errors.resume_installation?T.danger:T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                    {errors.resume_installation&&<div style={{fontSize:11,color:T.danger}}>{errors.resume_installation}</div>}
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📧 Email client</div>
                      <input type="email" value={rapport.email_client||""} onChange={e=>upR("email_client",e.target.value)} placeholder="client@exemple.fr"
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                    </div>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📋 Observations</div>
                      <input value={rapport.observations||""} onChange={e=>upR("observations",e.target.value)} placeholder="Remarques..."
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                    </div>
                  </div>
                </div>
              </div>
              ):isMaintenance?(
              /* ── MAINTENANCE : Checklist 12 points ── */
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {/* Type maintenance */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
                  <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Type de maintenance</div>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    {[["periodique","🔄 Périodique"],["corrective","🔧 Corrective"],["preventive","🛡️ Préventive"]].map(([val,lbl])=>(
                      <button key={val} onClick={()=>upR("type_maintenance",val)}
                        style={{padding:"9px 16px",borderRadius:9,border:`2px solid ${rapport.type_maintenance===val?T.success:T.border}`,background:rapport.type_maintenance===val?T.success+"22":"transparent",color:rapport.type_maintenance===val?T.success:T.muted,fontSize:13,fontWeight:700,cursor:"pointer"}}>
                        {lbl}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Compteur matériel */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
                  <Counter field="nb_cameras" label="Nombre de caméras vérifiées" icon="📷"/>
                </div>

                {/* Checklist 12 points */}
                {errors.checklist&&<div style={{padding:"10px 14px",borderRadius:9,background:"#ef444415",border:"1px solid #ef444430",color:"#ef4444",fontSize:12,fontWeight:700}}>⚠ {errors.checklist}</div>}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,overflow:"hidden"}}>
                  <div style={{padding:"12px 16px",background:"linear-gradient(135deg,#10b98115,#059f6315)",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",gap:10}}>
                    <span style={{fontSize:18}}>🔧</span>
                    <div>
                      <div style={{fontSize:13,fontWeight:800,color:T.text}}>CHECKLIST MAINTENANCE — Vidéosurveillance</div>
                      <div style={{fontSize:11,color:T.muted}}>Réf. : CHK-MAINT-001 · {CHECKLIST_MAINTENANCE.length} points de vérification</div>
                    </div>
                  </div>
                  <div style={{padding:0}}>
                    {CHECKLIST_MAINTENANCE.map((item,idx)=>{
                      const ch=getCheck(item.id);
                      return(
                        <div key={item.id} style={{padding:"12px 16px",borderBottom:idx<CHECKLIST_MAINTENANCE.length-1?`1px solid ${T.border}15`:"none",background:ch.valeur===true?"#10b98108":ch.valeur===false?"#ef444408":"transparent"}}>
                          <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                            <div style={{width:26,height:26,borderRadius:"50%",background:`${T.success}20`,border:`1px solid ${T.success}40`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,color:T.success,flexShrink:0,marginTop:1}}>{item.id}</div>
                            <div style={{flex:1}}>
                              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:2}}>{item.label}</div>
                              <div style={{fontSize:11,color:T.muted,marginBottom:8}}>{item.desc}</div>
                              <div style={{display:"flex",gap:8,marginBottom:ch.valeur!==null?8:0}}>
                                {[["✅ OK",true,"#10b981"],["❌ NON",false,"#ef4444"]].map(([lbl,val,col])=>(
                                  <button key={String(val)} onClick={()=>updChecklist(item.id,val,undefined)}
                                    style={{padding:"8px 16px",borderRadius:9,border:`2px solid ${ch.valeur===val?col:T.border}`,background:ch.valeur===val?col+"22":"transparent",color:ch.valeur===val?col:T.muted,fontSize:12,fontWeight:800,cursor:"pointer",minWidth:80}}>
                                    {lbl}
                                  </button>
                                ))}
                              </div>
                              {ch.valeur!==null&&(
                                <input value={ch.observations||""} onChange={e=>updChecklist(item.id,ch.valeur,e.target.value)} placeholder="Observations (optionnel)..."
                                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"6px 10px",color:T.text,fontSize:12,outline:"none",width:"100%"}}/>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Champs texte maintenance */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16,display:"flex",flexDirection:"column",gap:12}}>
                  {[
                    ["anomalies_trouvees","⚠️ Anomalies trouvées","Décrivez les anomalies constatées...",3],
                    ["actions_effectuees","🔧 Actions effectuées","Travaux réalisés, réglages, remplacements...",3],
                    ["pieces_remplacees","📦 Pièces remplacées","Références et quantités des pièces...",2],
                  ].map(([field,label,ph,rows])=>(
                    <div key={field}>
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:7}}>
                        <div style={{fontSize:13,fontWeight:700,color:T.text}}>{label}</div>
                        {field==="pieces_remplacees"&&<AiMaterielButton champ="pieces_remplacees"/>}
                      </div>
                      <textarea value={rapport[field]||""} onChange={e=>upR(field,e.target.value)} rows={rows} placeholder={ph}
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                    </div>
                  ))}
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📅 Prochaine visite</div>
                      <input type="date" value={rapport.prochaine_visite||""} onChange={e=>upR("prochaine_visite",e.target.value)}
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                    </div>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📧 Email client</div>
                      <input type="email" value={rapport.email_client||""} onChange={e=>upR("email_client",e.target.value)} placeholder="client@exemple.fr"
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%"}}/>
                    </div>
                  </div>
                  <div>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:7}}>
                      <div style={{fontSize:13,fontWeight:700,color:T.text}}>
                        📝 Résumé de l'intervention <span style={{color:T.danger}}>*</span>
                      </div>
                      <AiSynthButton champs={["anomalies_trouvees","actions_effectuees","pieces_remplacees"]} contexte={`Visite de maintenance chez ${i.client_nom||"le client"}`}/>
                    </div>
                    <textarea value={rapport.resume_intervention||""} onChange={e=>upR("resume_intervention",e.target.value)} rows={4} placeholder="Décrivez les travaux réalisés..."
                      style={{background:T.bg,border:`1px solid ${errors.resume_intervention?T.danger:T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                    {errors.resume_intervention&&<div style={{fontSize:11,color:T.danger}}>{errors.resume_intervention}</div>}
                  </div>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📋 Observations</div>
                    <textarea value={rapport.observations||""} onChange={e=>upR("observations",e.target.value)} rows={2} placeholder="Réserves, points à surveiller..."
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                  </div>
                </div>

                {/* Photos */}
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>📸 Photos de l'intervention</div>
                  {errors.photos&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.photos}</div>}
                  <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
                    <button onClick={()=>refCam.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📷 Caméra</button>
                    <button onClick={()=>refGal.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📁 Galerie</button>
                    {loadingPhotos&&<span style={{color:T.muted,fontSize:12,alignSelf:"center"}}>⏳ Envoi...</span>}
                  </div>
                  {pvPhotos.length>0&&(
                    <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                      {pvPhotos.map(ph=>(
                        <div key={ph.id} style={{position:"relative",width:90,height:90,borderRadius:8,overflow:"hidden",flexShrink:0}}>
                          <img src={ph.url} onClick={()=>setLightbox(ph.url)} style={{width:"100%",height:"100%",objectFit:"cover",cursor:"pointer"}} alt=""/>
                          <button onClick={()=>deletePhoto(ph.id)}
                            style={{position:"absolute",top:2,right:2,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:4,cursor:"pointer",fontSize:12,padding:"2px 6px",minWidth:24,minHeight:24}}>✕</button>
                        </div>
                      ))}
                    </div>
                  )}
                  {pvPhotos.length===0&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic"}}>Aucune photo — ajoutez des photos de l'intervention</div>}
                </div>
              </div>
              ):isFlash?(
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  {errors.checklist&&<div style={{padding:"10px 14px",borderRadius:9,background:"#ef444415",border:"1px solid #ef444430",color:"#ef4444",fontSize:12,fontWeight:700}}>⚠ {errors.checklist}</div>}
                  <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,overflow:"hidden"}}>
                    <div style={{padding:"12px 16px",background:"linear-gradient(135deg,#ef444415,#f59e0b15)",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",gap:10}}>
                      <span style={{fontSize:18}}>🔒</span>
                      <div>
                        <div style={{fontSize:13,fontWeight:800,color:T.text}}>COMPTE RENDU D'INSTALLATION — Système d'Alarme Ajax</div>
                        <div style={{fontSize:11,color:T.muted}}>Réf. : CHK-AJAX-001 · {CHECKLIST_AJAX.length} points de vérification</div>
                      </div>
                    </div>
                    <div style={{padding:0}}>
                      {CHECKLIST_AJAX.map((item,idx)=>{
                        const ch=getCheck(item.id);
                        return(
                          <div key={item.id} style={{padding:"12px 16px",borderBottom:idx<CHECKLIST_AJAX.length-1?`1px solid ${T.border}15`:"none",background:ch.valeur===true?"#10b98108":ch.valeur===false?"#ef444408":"transparent"}}>
                            <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                              <div style={{width:26,height:26,borderRadius:"50%",background:`${T.accent}20`,border:`1px solid ${T.accent}40`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,color:T.accent,flexShrink:0,marginTop:1}}>{item.id}</div>
                              <div style={{flex:1}}>
                                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:2}}>{item.label}</div>
                                <div style={{fontSize:11,color:T.muted,marginBottom:8}}>{item.desc}</div>
                                <div style={{display:"flex",gap:8,marginBottom:ch.valeur!==null?8:0}}>
                                  {[["✅ OK",true,"#10b981"],["❌ NON",false,"#ef4444"]].map(([lbl,val,col])=>(
                                    <button key={String(val)} onClick={()=>updChecklist(item.id,val,undefined)}
                                      style={{padding:"8px 16px",borderRadius:9,border:`2px solid ${ch.valeur===val?col:T.border}`,background:ch.valeur===val?col+"22":"transparent",color:ch.valeur===val?col:T.muted,fontSize:12,fontWeight:800,cursor:"pointer",minWidth:80}}>
                                      {lbl}
                                    </button>
                                  ))}
                                </div>
                                {ch.valeur!==null&&(
                                  <input value={ch.observations||""} onChange={e=>updChecklist(item.id,ch.valeur,e.target.value)} placeholder="Observations (optionnel)..."
                                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"6px 10px",color:T.text,fontSize:12,outline:"none",width:"100%"}}/>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {/* Compteur matériel */}
                  <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16}}>
                    <Counter field="nb_detecteurs" label="Nombre de détecteurs installés" icon="🔔"/>
                  </div>

                  {/* Email + résumé */}
                  <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16,display:"flex",flexDirection:"column",gap:12}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📧 Email client <span style={{fontSize:11,color:T.muted,fontWeight:400}}>(envoi automatique du PV PDF après signature)</span></div>
                      <input value={rapport.email_client||""} onChange={e=>upR("email_client",e.target.value)} placeholder="client@exemple.fr" type="email"
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                    </div>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📝 Résumé de l'installation <span style={{color:T.danger}}>*</span></div>
                      <textarea value={rapport.resume_installation||""} onChange={e=>upR("resume_installation",e.target.value)} rows={4} placeholder="Matériels installés, zones configurées, tests effectués..."
                        style={{background:T.bg,border:`1px solid ${errors.resume_installation?T.danger:T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                      {errors.resume_installation&&<div style={{fontSize:11,color:T.danger}}>{errors.resume_installation}</div>}
                    </div>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>📋 Observations générales</div>
                      <textarea value={rapport.observations_flash||""} onChange={e=>upR("observations_flash",e.target.value)} rows={3} placeholder="Réserves, points à surveiller..."
                        style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                    </div>
                  </div>

                  {/* ── Photos PV ── */}
                  <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16}}>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>📸 Photos de l'installation</div>
                    {errors.photos&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.photos}</div>}
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>

                          <button onClick={()=>refCam.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📷 Caméra</button>
                          <button onClick={()=>refGal.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"10px 16px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📁 Galerie</button>
                          {loadingPhotos&&<span style={{color:T.muted,fontSize:12,alignSelf:"center"}}>⏳ Envoi...</span>}
                        </div>
                    {pvPhotos.length>0&&(
                      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                        {pvPhotos.map(ph=>(
                          <div key={ph.id} style={{position:"relative",width:90,height:90,borderRadius:8,overflow:"hidden",flexShrink:0}}>
                            <img src={ph.url} onClick={()=>setLightbox(ph.url)} style={{width:"100%",height:"100%",objectFit:"cover",cursor:"pointer"}} alt=""/>
                            <button onClick={()=>deletePhoto(ph.id)}
                              style={{position:"absolute",top:2,right:2,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:4,cursor:"pointer",fontSize:12,padding:"2px 6px",minWidth:24,minHeight:24}}>✕</button>
                          </div>
                        ))}
                      </div>
                    )}
                    {pvPhotos.length===0&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic"}}>Aucune photo — ajoutez des photos de l'installation</div>}
                  </div>
                </div>
              ):(
              /* ── PACK SENTINELLE : Questionnaire Vidéo ── */
              <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:20,display:"flex",flexDirection:"column",gap:4}}>
                <YesNo field="nvr_installe" label="1. L'enregistreur fonctionne avec toutes ses caméras ?"/>
                {rapport.nvr_installe!==null&&<YesNo field="nvr_fonctionnel" label="2. Les caméras ont-elles été renommées ?"/>}
                <div style={{height:1,background:T.border,margin:"6px 0"}}/>
                <YesNo field="connecte_internet" label="3. L'enregistreur est-il enregistré sur Dolynkcare ?"/>
                {rapport.connecte_internet===true&&(
                  <div style={{marginLeft:14,paddingLeft:14,borderLeft:`3px solid ${T.success}`}}>
                    <YesNo field="connecte_dolynkcare" label="4. Le système est-il à l'heure et sans défaut ?"/>
                  </div>
                )}
                {rapport.connecte_internet===false&&(
                  <div style={{marginLeft:14,paddingLeft:14,borderLeft:`3px solid ${T.danger}`,marginBottom:12}}>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>3a. Raison <span style={{color:T.danger}}>*</span></div>
                    <textarea value={rapport.raison_non_connexion||""} onChange={e=>upR("raison_non_connexion",e.target.value)} rows={3} placeholder="Expliquez pourquoi..."
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical"}}/>
                    {errors.raison_non_connexion&&<div style={{fontSize:11,color:T.danger}}>{errors.raison_non_connexion}</div>}
                  </div>
                )}
                <div style={{height:1,background:T.border,margin:"6px 0"}}/>
                <div style={{marginBottom:14}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>4. Email client <span style={{fontSize:11,color:T.muted,fontWeight:400}}>(pour envoi du PV)</span></div>
                  <input value={rapport.email_client||""} onChange={e=>upR("email_client",e.target.value)} placeholder="client@exemple.fr" type="email"
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                </div>
                <div style={{height:1,background:T.border,margin:"6px 0"}}/>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:7}}>
                    5. Résumé <span style={{color:T.danger}}>*</span>
                    <span style={{fontSize:11,color:rapport.resume_installation?.length>=20?T.success:T.muted,fontWeight:400,marginLeft:8}}>{rapport.resume_installation?.length||0}/20 min</span>
                  </div>
                  <textarea value={rapport.resume_installation||""} onChange={e=>upR("resume_installation",e.target.value)} rows={5} placeholder="Décrivez le travail effectué..."
                    style={{background:T.bg,border:`1px solid ${errors.resume_installation?T.danger:rapport.resume_installation?.length>=20?T.success:T.border}`,borderRadius:9,padding:"10px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",lineHeight:1.6}}/>
                  {errors.resume_installation&&<div style={{fontSize:11,color:T.danger}}>{errors.resume_installation}</div>}
                </div>

                {/* Zones caméras */}
                {isSentinelle&&(
                  <div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${T.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                      <div style={{fontSize:13,fontWeight:700,color:T.text}}>📷 Zones caméras ({pvCameras.length})</div>
                      <div style={{display:"flex",gap:6}}>
                        <button onClick={()=>setPvCameras(p=>[...p,{numero_camera:p.length+1,zone:"",localisation:"",type_camera:"",ip:"",hdcvi:false,notes:""}])}
                          style={{padding:"4px 10px",borderRadius:7,background:"#10b98115",border:"1px solid #10b98130",color:"#10b981",fontSize:11,fontWeight:700,cursor:"pointer"}}>+ Caméra</button>
                        {pvCameras.length>1&&<button onClick={()=>setPvCameras(p=>p.slice(0,-1))}
                          style={{padding:"4px 10px",borderRadius:7,background:"#ef444415",border:"1px solid #ef444430",color:"#ef4444",fontSize:11,fontWeight:700,cursor:"pointer"}}>− Retirer</button>}
                        <button onClick={async()=>{
                          const toSave=pvCameras.filter(c=>c.zone||c.localisation||c.ip);
                          await fetch(`${BASE}/zones/${i.id}/cameras`,{method:"POST",headers:h(),body:JSON.stringify({cameras:toSave})}).catch(()=>{});
                        }} style={{padding:"4px 10px",borderRadius:7,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:11,fontWeight:700,cursor:"pointer"}}>💾 Sauver</button>
                      </div>
                    </div>
                    <div style={{overflowX:"auto"}}>
                      <table style={{width:"100%",borderCollapse:"collapse",fontSize:11,minWidth:500}}>
                        <thead><tr style={{background:T.bg}}>{["CAM","Zone / Nom","Localisation","Type","IP / HDCVI","Notes"].map(h2=><th key={h2} style={{padding:"6px 8px",textAlign:"left",color:T.muted,fontWeight:700,fontSize:9,textTransform:"uppercase",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{h2}</th>)}</tr></thead>
                        <tbody>
                          {pvCameras.map((cam,idx)=>(
                            <tr key={cam.numero_camera} style={{borderBottom:`1px solid ${T.border}15`}}>
                              <td style={{padding:"5px 8px",fontWeight:800,color:T.accent,whiteSpace:"nowrap",fontSize:12}}>#{cam.numero_camera}</td>
                              {[["zone","Ex: Hall entrée"],["localisation","Plafond, mur..."],["type_camera","Dôme, Bullet..."],["ip","192.168.x.x"]].map(([k,ph])=>(
                                <td key={k} style={{padding:"4px 5px"}}>
                                  <input value={cam[k]||""} onChange={e=>setPvCameras(p=>p.map((c,i)=>i===idx?{...c,[k]:e.target.value}:c))} placeholder={ph}
                                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 7px",color:T.text,fontSize:11,outline:"none",width:"100%",minWidth:70}}/>
                                </td>
                              ))}
                              <td style={{padding:"4px 5px"}}>
                                <input value={cam.notes||""} onChange={e=>setPvCameras(p=>p.map((c,i)=>i===idx?{...c,notes:e.target.value}:c))} placeholder="Observations..."
                                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 7px",color:T.text,fontSize:11,outline:"none",width:"100%",minWidth:80}}/>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Photos installation */}
                <div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${T.border}`}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}}>📸 Photos de l'installation</div>
                  {errors.photos&&<div style={{fontSize:11,color:T.danger,marginBottom:8}}>⚠ {errors.photos}</div>}
                  <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
                    <button onClick={()=>refCam.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"9px 14px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📷 Caméra</button>
                    <button onClick={()=>refGal.current.click()} style={{display:"inline-flex",alignItems:"center",gap:7,padding:"9px 14px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}30`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer",minHeight:44}}>📁 Galerie</button>
                    {loadingPhotos&&<span style={{color:T.muted,fontSize:12,alignSelf:"center"}}>⏳ Envoi...</span>}
                  </div>
                  {pvPhotos.length>0&&(
                    <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                      {pvPhotos.map(ph=>(
                        <div key={ph.id} style={{position:"relative",width:80,height:80,borderRadius:8,overflow:"hidden",flexShrink:0}}>
                          <img src={ph.url} onClick={()=>setLightbox(ph.url)} style={{width:"100%",height:"100%",objectFit:"cover",cursor:"pointer"}} alt=""/>
                          <button onClick={()=>deletePhoto(ph.id)}
                            style={{position:"absolute",top:2,right:2,background:"rgba(220,38,38,0.85)",border:"none",color:"#fff",borderRadius:4,cursor:"pointer",fontSize:12,padding:"2px 5px"}}>✕</button>
                        </div>
                      ))}
                    </div>
                  )}
                  {pvPhotos.length===0&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic"}}>Aucune photo ajoutée</div>}
                </div>
              </div>
              )}
            </div>
          )}

          {step==="signatures"&&(
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              <div>
                <div style={{fontSize:18,fontWeight:800,color:T.text}}>✍️ Signatures finales</div>
                <div style={{fontSize:13,color:T.muted,marginTop:3}}>Signature au doigt · Les deux sont <strong style={{color:T.danger}}>obligatoires</strong></div>
              </div>
              <div style={{background:T.accentDim,border:`1px solid ${T.accent}30`,borderRadius:13,padding:14}}>
                <div style={{fontSize:11,fontWeight:700,color:T.accent,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.5px"}}>📋 Récapitulatif final</div>
                {isMaintenance?(
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,color:T.muted}}>
                    <span>Type : <strong style={{color:T.text}}>{rapport.type_maintenance||"périodique"}</strong></span>
                    <span>Checklist : <strong style={{color:T.text}}>{(rapport.checklist||[]).filter(c=>c.valeur!==null).length}/{CHECKLIST_MAINTENANCE.length} ✅</strong></span>
                    <span>Caméras vérifiées : <strong style={{color:T.text}}>{rapport.nb_cameras||0}</strong></span>
                    <span>Photos : <strong style={{color:pvPhotos.length>0?T.success:T.danger}}>{pvPhotos.length}</strong></span>
                    <span>Résumé : <strong style={{color:rapport.resume_intervention?.length>=10?T.success:T.danger}}>{rapport.resume_intervention?.length>=10?"✅ OK":"⚠ Manquant"}</strong></span>
                    <span>Email : <strong style={{color:T.text}}>{rapport.email_client||"—"}</strong></span>
                  </div>
                ):isSav?(
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,color:T.muted}}>
                    <span>Système : <strong style={{color:T.text}}>{rapport.type_systeme==="alarme"?"🔒 Alarme":"📷 Vidéo"}</strong></span>
                    <span>Motifs : <strong style={{color:T.text}}>{(rapport.motifs||[]).length} sélectionné(s)</strong></span>
                    <span>Résultat : <strong style={{color:rapport.resultat==="resolu"?T.success:rapport.resultat==="partiel"?"#f59e0b":"#ef4444"}}>{rapport.resultat==="resolu"?"✅ Résolu":rapport.resultat==="partiel"?"🔄 Partiel":rapport.resultat==="non_resolu"?"❌ Non résolu":"—"}</strong></span>
                    <span>Photos : <strong style={{color:pvPhotos.length>0?T.success:T.danger}}>{pvPhotos.length}</strong></span>
                    <span>Email : <strong style={{color:T.text}}>{rapport.email_client||"—"}</strong></span>
                  </div>
                ):isCashBox?(
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,color:T.muted}}>
                    <span>Équipements : <strong style={{color:T.text}}>{Object.values(rapport.equipements||{}).filter(q=>q>0).length} type(s)</strong></span>
                    <span>Packs Cash Box : <strong style={{color:T.text}}>{rapport.nb_packs_cashbox||0}</strong></span>
                    <span>Tests : <strong style={{color:T.text}}>{(rapport.checklist_tests||[]).filter(t=>t.valeur===true).length}/{TESTS_CASH_BOX.length} ✅</strong></span>
                    <span>Photos : <strong style={{color:pvPhotos.length>0?T.success:T.danger}}>{pvPhotos.length}</strong></span>
                    <span>Logiciel : <strong style={{color:T.text}}>{rapport.logiciel||"—"}</strong></span>
                    <span>Email : <strong style={{color:T.text}}>{rapport.email_client||"—"}</strong></span>
                  </div>
                ):isFlash?(
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,color:T.muted}}>
                    <span>Checklist : <strong style={{color:T.text}}>{(rapport.checklist||[]).filter(c=>c.valeur!==null).length}/{CHECKLIST_AJAX.length} ✅</strong></span>
                    <span>Détecteurs installés : <strong style={{color:T.text}}>{rapport.nb_detecteurs||0}</strong></span>
                    <span>Photos : <strong style={{color:pvPhotos.length>0?T.success:T.danger}}>{pvPhotos.length}</strong></span>
                    <span>Résumé : <strong style={{color:rapport.resume_installation?.length>=10?T.success:T.danger}}>{rapport.resume_installation?.length>=10?"✅ OK":"⚠ Manquant"}</strong></span>
                    <span>Email : <strong style={{color:T.text}}>{rapport.email_client||"—"}</strong></span>
                  </div>
                ):(
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12,color:T.muted}}>
                    <span>NVR : <strong style={{color:T.text}}>{rapport.nvr_installe===null?"—":rapport.nvr_installe?"Installé ✅":"Non ❌"}</strong></span>
                    <span>Internet : <strong style={{color:T.text}}>{rapport.connecte_internet===null?"—":rapport.connecte_internet?"Connecté ✅":"Non ❌"}</strong></span>
                    <span>Dolynkcare : <strong style={{color:T.text}}>{rapport.connecte_dolynkcare===null?"—":rapport.connecte_dolynkcare?"Oui ✅":"Non ❌"}</strong></span>
                    <span>Caméras : <strong style={{color:T.text}}>{rapport.nb_cameras||0}</strong></span>
                    <span>Photos : <strong style={{color:pvPhotos.length>0?T.success:T.danger}}>{pvPhotos.length}</strong></span>
                    <span>Résumé : <strong style={{color:rapport.resume_installation?.length>=20?T.success:T.danger}}>{rapport.resume_installation?.length>=20?"✅ OK":"⚠ Manquant"}</strong></span>
                  </div>
                )}
              </div>
              <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:13,padding:16}}>
                <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Informations de signature</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  <div>
                    <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Fait à</label>
                    <input value={rapport.lieu_signature||""} onChange={e=>upR("lieu_signature",e.target.value)} placeholder="Ville..."
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Date</label>
                    <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:14,color:T.text,fontWeight:600}}>{new Date().toLocaleDateString("fr-FR")}</div>
                  </div>
                </div>
              </div>
              <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:13,padding:16}}>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",display:"block",marginBottom:10}}>Nom et qualité du signataire client</label>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  <input value={rapport.nom_signataire||""} onChange={e=>upR("nom_signataire",e.target.value)} placeholder="Nom complet..."
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",color:T.text,fontSize:14,outline:"none"}}/>
                  <input value={rapport.qualite_signataire||""} onChange={e=>upR("qualite_signataire",e.target.value)} placeholder="Qualité (ex: Gérant)..."
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",color:T.text,fontSize:14,outline:"none"}}/>
                </div>
              </div>

              {odooSignAvailable ? (
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  {!odooSign ? (
                    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:13,padding:20,textAlign:"center"}}>
                      <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:6}}>✍️ Signature électronique Odoo</div>
                      <div style={{fontSize:12,color:T.muted,marginBottom:14}}>Le technicien signe en premier, puis le client sur le même écran.</div>
                      {odooSignError&&<div style={{fontSize:12,color:T.danger,fontWeight:600,marginBottom:10}}>⚠ {odooSignError}</div>}
                      <button onClick={startOdooSign} disabled={odooSignLoading} style={{padding:"12px 24px",borderRadius:10,background:T.accent,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:odooSignLoading?"wait":"pointer"}}>
                        {odooSignLoading?"Préparation…":"🖊️ Démarrer la signature"}
                      </button>
                    </div>
                  ) : (rapport.signature_technicien==="ODOO_SIGN" && rapport.signature_client==="ODOO_SIGN") ? (
                    <div style={{background:`${T.success}15`,border:`1px solid ${T.success}40`,borderRadius:13,padding:16,textAlign:"center"}}>
                      <div style={{fontSize:14,fontWeight:700,color:T.success}}>✅ Signatures technicien et client complètes</div>
                    </div>
                  ) : (
                    <div style={{border:`1px solid ${T.border}`,borderRadius:13,overflow:"hidden"}}>
                      <div style={{padding:"10px 14px",background:T.card,borderBottom:`1px solid ${T.border}`,fontSize:12.5,fontWeight:700,color:T.text}}>
                        {odooSignPhase==="technicien" ? "✍️ Signature du technicien en cours…" : "🖊️ Au tour du client de signer…"}
                      </div>
                      <iframe
                        key={odooSignPhase}
                        title="Signature Odoo"
                        src={`${odooSign.baseUrl}/sign/document/${odooSign.signRequestId}/${odooSignPhase==="technicien"?odooSign.technicien.token:odooSign.client.token}`}
                        style={{width:"100%",height:520,border:"none",display:"block"}}
                      />
                    </div>
                  )}
                  {(errors.signature_technicien||errors.signature_client)&&<div style={{fontSize:12,color:T.danger,fontWeight:600}}>⚠ Les deux signatures sont obligatoires</div>}
                </div>
              ) : (
                <>
                  <SignaturePad T={T} label="✍️ Signature du technicien" hint={`Je soussigné ${i.technicien_nom||"le technicien"} certifie avoir réalisé l'installation`} value={rapport.signature_technicien||""} onChange={v=>upR("signature_technicien",v)}/>
                  {errors.signature_technicien&&<div style={{fontSize:12,color:T.danger,fontWeight:600}}>⚠ {errors.signature_technicien}</div>}
                  <SignaturePad T={T} label="🖊️ Signature du client" hint="Le client certifie avoir été informé et accepte les travaux réalisés" value={rapport.signature_client||""} onChange={v=>upR("signature_client",v)}/>
                  {errors.signature_client&&<div style={{fontSize:12,color:T.danger,fontWeight:600}}>⚠ {errors.signature_client}</div>}
                </>
              )}

              <div style={{padding:"12px 14px",background:T.bg,borderRadius:10,border:`1px solid ${T.border}`,fontSize:11,color:T.muted,lineHeight:1.6}}>
                📄 En signant, les parties reconnaissent la bonne réalisation conformément aux conditions GS-GROUP · {new Date().toLocaleDateString("fr-FR")}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div style={{background:T.sidebar,borderTop:`1px solid ${T.border}`,padding:"12px 20px",display:"flex",gap:10,flexShrink:0}}>
        {step!=="info"&&<button onClick={()=>setStep(steps[stepIdx-1].id)} style={{padding:"11px 18px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:14,fontWeight:600,cursor:"pointer"}}>← Précédent</button>}
        <div style={{flex:1}}/>
        {step==="info"&&<button onClick={()=>setStep("questionnaire")} style={{padding:"11px 22px",borderRadius:10,background:T.accent,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>✅ Suivant → Questionnaire</button>}
        {step==="questionnaire"&&<button onClick={()=>{if(validateQ()){saveDraft();setStep("signatures");}}} style={{padding:"11px 22px",borderRadius:10,background:T.accent,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>✍️ Suivant → Signatures</button>}
        {step==="signatures"&&<button onClick={handleFinish} disabled={saving} style={{padding:"11px 28px",borderRadius:10,background:rapport.signature_technicien&&rapport.signature_client?`linear-gradient(135deg,${T.success},#16a34a)`:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:800,cursor:rapport.signature_technicien&&rapport.signature_client?"pointer":"not-allowed",opacity:saving?0.7:1}}>{saving?"Validation...":"✅ Valider et clôturer"}</button>}
      </div>

      {/* Modal PV Intermédiaire */}
      {showPVI&&<PVIntermediaire T={T} intervention={i} onClose={()=>setShowPVI(false)}/>}
    </div>
      {lightbox&&(
        <div onClick={()=>setLightbox(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.95)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",cursor:"zoom-out"}}>
          <img src={lightbox} style={{maxWidth:"95vw",maxHeight:"95vh",objectFit:"contain",borderRadius:8}}/>
          <button onClick={()=>setLightbox(null)} style={{position:"absolute",top:16,right:16,background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",borderRadius:"50%",width:40,height:40,fontSize:20,cursor:"pointer"}}>✕</button>
        </div>
      )}

      {/* Confirmation matériel détecté par l'IA */}
      {aiMaterielItems!==null&&(
        <div onClick={()=>setAiMaterielItems(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div onClick={e=>e.stopPropagation()} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,width:380,maxWidth:"100%",maxHeight:"80vh",display:"flex",flexDirection:"column",overflow:"hidden"}}>
            <div style={{padding:"16px 18px",borderBottom:`1px solid ${T.border}`}}>
              <div style={{fontSize:15,fontWeight:800,color:T.text}}>✨ Matériel détecté</div>
              <div style={{fontSize:11.5,color:T.muted,marginTop:2}}>Décochez ce qui n'est pas correct avant de confirmer.</div>
            </div>
            <div style={{overflowY:"auto",padding:"8px 10px"}}>
              {aiMaterielItems.length===0&&<div style={{padding:20,textAlign:"center",fontSize:12.5,color:T.muted}}>Aucun produit du stock reconnu dans le texte.</div>}
              {aiMaterielItems.map((it,idx)=>(
                <label key={idx} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 10px",borderRadius:10,cursor:"pointer"}}>
                  <input type="checkbox" checked={it.selected} onChange={()=>setAiMaterielItems(items=>items.map((x,xi)=>xi===idx?{...x,selected:!x.selected}:x))}/>
                  <div style={{flex:1,fontSize:12.5,color:T.text}}>{it.designation}</div>
                  <span style={{fontSize:12,fontWeight:700,color:T.accent}}>×{it.quantite}</span>
                </label>
              ))}
            </div>
            <div style={{padding:"12px 18px",borderTop:`1px solid ${T.border}`,display:"flex",gap:8}}>
              <button onClick={()=>setAiMaterielItems(null)} style={{flex:1,padding:"9px",borderRadius:9,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:12.5,fontWeight:700,cursor:"pointer"}}>Annuler</button>
              <button onClick={confirmerMateriel} disabled={!aiMaterielItems.some(it=>it.selected)} style={{flex:1,padding:"9px",borderRadius:9,border:"none",background:T.accent,color:"#fff",fontSize:12.5,fontWeight:700,cursor:"pointer",opacity:aiMaterielItems.some(it=>it.selected)?1:0.5}}>Confirmer la sortie de stock</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
